import { useAccountDrawer } from '../AccountDrawer';
import PopupItem from './PopupItem';

import { cn } from 'utils/cn';

import { useActivePopups } from 'state/application/hooks';

const Popups = () => {
  const [isAccountDrawerOpen] = useAccountDrawer();

  const activePopups = useActivePopups();

  return (
    <>
      <div
        className={cn(
          'fixed right-4 z-modal w-full auto-rows-auto transition-all duration-700 ease-in-out',
          'hidden lg:grid',
          'max-w-87 gap-y-5',
          {
            'top-16': !isAccountDrawerOpen,
            'top-4': isAccountDrawerOpen
          }
        )}
      >
        {activePopups.map((item) => (
          <PopupItem
            key={item.key}
            content={item.content}
            popKey={item.key}
            removeAfterMs={item.removeAfterMs}
          />
        ))}
      </div>

      {activePopups?.length > 0 && (
        <div className='relative mx-auto my-0 block max-w-full px-5 pt-5 lg:hidden lg:pt-0'>
          <div className='custom-scrollbar flex h-full flex-row overflow-x-auto overflow-y-hidden'>
            {activePopups // reverse so new items up front
              .slice(0)
              .reverse()
              .map((item) => (
                <PopupItem
                  key={item.key}
                  content={item.content}
                  popKey={item.key}
                  removeAfterMs={item.removeAfterMs}
                />
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Popups;
